module.exports = __webpack_public_path__ + "static/media/55.c29ee519.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/55.png
// module id = 480
// module chunks = 0